import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547fef4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 border-img" }
const _hoisted_2 = { class: "img-product" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "py-3 px-2" }
const _hoisted_5 = {
  style: {"-webkit-line-clamp":"1"},
  class: "text-claim font-small"
}
const _hoisted_6 = {
  key: 0,
  class: "text-claim font-weight-bold text-gray-iwari d-flex"
}
const _hoisted_7 = {
  class: "form-check-label ml-1",
  for: "promotion"
}
const _hoisted_8 = {
  key: 1,
  style: {"-webkit-line-clamp":"1"},
  class: "text-claim font-weight-bold text-gray-iwari"
}
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "w-100" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "w-header" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-muted mb-0 mr-2" }, "Tallas:")
], -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-block text-muted mb-0 mr-2" }, "Colores:")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pt-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mr-2" }, "Precio:")
], -1))
const _hoisted_16 = { class: "pt-2" }
const _hoisted_17 = { class: "ml-1 mb-0 font-weight-bold" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "deep-orange-text" }, "S/", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = {
  class: "deep-orange-text",
  id: "spanPrice"
}
const _hoisted_21 = {
  key: 0,
  id: "spanPriceOffer",
  class: "font-small text-strike ml-2"
}
const _hoisted_22 = {
  key: 1,
  class: "btn btn-deep-orange btn-rounded shadow-none ml-3 px-2 py-2 d-inline"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "local_offer", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  name: "price",
  id: "price",
  type: "hidden",
  value: "0"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_dropdown = _resolveComponent("custom-dropdown")!

  return (_ctx.product != null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.product.selected ? '' : 'opacity')
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.currentPhoto,
              alt: ""
            }, null, 8, _hoisted_3)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.product.attributes.brand), 1),
          (_ctx.frequents)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.selected) = $event)),
                  type: "checkbox",
                  value: "1",
                  id: "promotion",
                  style: {"margin-top":"0.3rem"}
                }, null, 512), [
                  [_vModelCheckbox, _ctx.product.selected]
                ]),
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.product.name), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.product.name), 1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              (_ctx.product.attributes.dimensions !== 'custom' && _ctx.sizeSelectable && _ctx.sizeOptions.length && _ctx.sizeOptions[0].label)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("td", null, [
                      _createVNode(_component_custom_dropdown, {
                        tabindex: 1,
                        options: _ctx.sizeOptions,
                        onSelectOption: _ctx.selectPresentation,
                        selected: _ctx.sizeSelected,
                        width100: true
                      }, null, 8, ["options", "onSelectOption", "selected"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.colorOptions.length && _ctx.colorOptions[0].label)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _createVNode(_component_custom_dropdown, {
                        tabindex: 1,
                        options: _ctx.colorOptions,
                        onSelectOption: _ctx.selectColor,
                        selected: _ctx.colorSelected,
                        selectEmpty: true,
                        width100: true
                      }, null, 8, ["options", "onSelectOption", "selected"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("h5", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.price.toFixed(2)), 1),
                    (_ctx.strike)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "S/ " + _toDisplayString(_ctx.strike), 1))
                      : _createCommentVNode("", true),
                    (_ctx.product.offer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" -" + _toDisplayString(_ctx.product.offer.percent) + "%", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_24
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}